import { reatomAsync, withDataAtom, withErrorAtom } from "@reatom/async";
import { withAbort } from "@reatom/framework";
import { TemplatePreviewRequestDto } from "definitions/exporter";
import { API } from "src/api.ts";
import { withIsLoadingAtom } from "src/common/pipes";
import { normalizeTemplateError } from "src/pages/ExportPage/widgets/ExportTasksForm/widgets/TemplatesForm/templateApiErrors";

// Live-preview шаблонов на сэмплах товаров. withAbort обрывает предыдущий
// запрос когда юзер быстро правит шаблон. Дебаунс снаружи (через хук-обёртку),
// чтобы не сериализовать payload на каждый keystroke.
//
// Ошибки нормализуем в TemplateApiError на месте — иначе reatom выбросит сырую
// AxiosError, и UI потеряет discriminated union с parse/unknown/other.
export const getTemplatePreviewRequest = reatomAsync(
  async (ctx, payload: TemplatePreviewRequestDto) => {
    try {
      const response =
        await API.exporterQueueApi.exportControllerPreviewTemplate(payload, {
          signal: ctx.controller.signal,
        });
      return response.data;
    } catch (error) {
      throw normalizeTemplateError(error);
    }
  },
  "getTemplatePreviewRequest",
).pipe(withDataAtom(null), withErrorAtom(), withAbort(), withIsLoadingAtom());
